import { defineEvent } from '#src/analytics/analytics_event.ts';
import { z } from 'zod';

export const WishlistItemCreateEvent = defineEvent(
  'wishlist:item_create',
  z.object({
    isSuccess: z.boolean(),
    hasUrl: z.boolean(),
    hasNote: z.boolean(),
    retailerName: z.string().trim().nonempty().nullable(),
    retailerId: z.string().trim().nonempty().nullable(),
    itemCount: z.number().int().nonnegative().nullable(),
  }),
  {
    isSuccess: 'is_success',
    hasUrl: 'has_url',
    hasNote: 'has_note',
    retailerName: 'retailer_name',
    retailerId: 'retailer_id',
    itemCount: 'item_count',
  },
);

export const WishlistItemUpdateEvent = defineEvent(
  'wishlist:item_update',
  z.object({
    isSuccess: z.boolean(),
    hasUrl: z.boolean(),
    hasNote: z.boolean(),
    retailerName: z.string().trim().nonempty().nullable(),
    retailerId: z.string().trim().nonempty().nullable(),
  }),
  {
    isSuccess: 'is_success',
    hasUrl: 'has_url',
    hasNote: 'has_note',
    retailerName: 'retailer_name',
    retailerId: 'retailer_id',
  },
);

export const WishlistItemDeleteEvent = defineEvent(
  'wishlist:item_delete',
  z.object({
    isSuccess: z.boolean(),
    itemCount: z.number().int().nonnegative().nullable(),
  }),
  {
    isSuccess: 'is_success',
    itemCount: 'item_count',
  },
);

export const WishlistMatchListViewEvent = defineEvent(
  'wishlist:match_list_view',
  z.object({
    itemCount: z.number().int().nonnegative(),
    affiliatedItemCount: z.number().int().nonnegative(),
  }),
  {
    itemCount: 'item_count',
    affiliatedItemCount: 'affiliated_item_count',
  },
);

export const WishlistLinkClickEvent = defineEvent(
  'wishlist:link_click',
  z.object({
    retailerName: z.string().trim().nonempty().nullable(),
    retailerId: z.string().trim().nonempty().nullable(),
  }),
  {
    retailerName: 'retailer_name',
    retailerId: 'retailer_id',
  },
);
